import get from "lodash/get";

// @ts-expect-error legacy code
import {checkFeatures} from "@/pages/rum/v2/CheckFeatures.js";
// @ts-expect-error legacy code
import {getBaselineComparison, renderBaselineComparison} from "@/pages/rum/v2/RumUtils.jsx";

interface RUMErrorComparisonProps {
  rowData: object;
}

export const RUMErrorComparison = ({rowData}: RUMErrorComparisonProps) => {
  const {errorRate4xx, errorRate5xx, errorRateJS} = checkFeatures;
  // Only display the worst error rate on this page.
  let errorRateFeature, errorRateData;
  for (const feature of [errorRate4xx, errorRate5xx, errorRateJS]) {
    const thisData = rowData ? get(rowData, feature.deltaPct, 0) : undefined;
    if (!errorRateData || thisData > errorRateData) {
      errorRateData = thisData;
      errorRateFeature = feature;
    }
  }
  const errorRateComparison = getBaselineComparison(errorRateFeature, rowData);
  if (errorRateComparison) {
    errorRateComparison.subLabel = ` (${errorRateFeature.shortName})`;
  }

  return renderBaselineComparison(errorRateComparison, {subLabel: errorRateComparison?.subLabel, delta: errorRateData});
};
